const styles = {
  modal: {
    '& .MuiPaper-root': {
      maxWidth: 480,
    },
  },
  alert: {
    mt: 4,
  },
  link: {
    fontFamily: 'Arial, sans-serif',
    fontSize: 12,
    lineHeight: 1.33,
  },
  printPositionPreview: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: 4,
    gap: 3,
  },
  selectWrapper: { width: '100%' },
  selectLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}

export default styles
